import * as React from 'react';
import * as styles from './styles.css';

export interface IMarketAnalyticsBannerProps {
  url: string;
}

export function MarketAnalyticsBanner({ url }: IMarketAnalyticsBannerProps) {
  return (
    <a href={url} className={styles['container']}>
      Как кризис
      <br />и самоизоляция
      <br />
      влияют
      <br />
      на рынок жилья
    </a>
  );
}
